import { BrowserRouter as Router, Route, Switch, useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ArrowBackIcon, AddIcon } from '@chakra-ui/icons';
import { ChakraProvider, Center, Button, Link, Box, Heading, Text, theme, Icon, VStack, HStack, Card, CardBody, Stack, Select, FormControl, SimpleGrid, } from '@chakra-ui/react';
import firebase from 'firebase/app';
import { auth, db } from "../firebase-config";
import {collectionGroup, collection, query, getDocs, where, orderBy} from 'firebase/firestore';
import { ChevronDownIcon} from '@chakra-ui/icons';
import alumniDoor from '../assets/alumniDoor.jpg';
import skyTwo from '../assets/skyTwo.jpg';



export default function DeptPage() {
    const { departmentName } = useParams();
    const [department, setDepartment] = useState("");
    const [departmentCode, setDepartmentCode] = useState("");
    const [departmentDocID, setDepartmentDocID] = useState("");
    const [courseNums, setCourseNums] = useState([]);
    const [courseMap, setCourseMap] = useState(new Map());
    const [noReviews, setNoReviews] = useState(false);
    const [height, setHeight] = useState(null);

    useEffect(() => {
      if (courseMap.size > 0) {
        var finalArr = [];
        courseMap.forEach((value, key) => {
          finalArr.push([value, key]);
        });
        setCourseNums(finalArr);
      } else if (courseMap.size === 0 && departmentDocID !== "") {
        setNoReviews(true);
      }
    }, [courseMap]);
    let navigate = useNavigate();
    const RouteChange = () =>{
    let path = '/not-found';    
    navigate(path);
    }

    useEffect(() => {
      document.body.style.background = 'lightyellow';
      const searchQuery = async () => {
        const q = query(collection(db, "departments"), where("deptCode", "==", departmentName));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.size === 0) {
          
          RouteChange();
        } else {
            // only done once - this is one document that sets these variables everywhere
          querySnapshot.forEach((doc) => {
            setDepartmentDocID(doc.id);  
            setDepartment(doc.data()["deptName"]);
            setDepartmentCode(doc.data()["deptCode"]);
          });
          const info = query(collection(db, `departments/${departmentDocID}/courses`), orderBy("courseNum"));
          const querySnapshot3 = await getDocs(info);
          var allInfoCourseMap = new Map();
          querySnapshot3.forEach((doc) => {
            if (allInfoCourseMap.has(doc.data()["courseNum"])) {
              allInfoCourseMap.set(doc.data()["courseNum"], [(allInfoCourseMap.get(doc.data()["courseNum"]))[0] + 1, (allInfoCourseMap.get(doc.data()["courseNum"]))[1]+doc.data()["diffRating"],(allInfoCourseMap.get(doc.data()["courseNum"]))[2]+doc.data()["qualityRating"]]);
            } else {
              allInfoCourseMap.set(doc.data()["courseNum"], [1, doc.data()["diffRating"],doc.data()["qualityRating"]]);
            }
          })
          setCourseMap(allInfoCourseMap);   
        }
      }
          
      searchQuery();    
    }, [departmentDocID, departmentName]);

    useEffect(() => {
      const calculateHeight = () => {
        const minHeight = 100; 
        const maxHeight = 800; 
        const numCoursesRange = 20;
        const heightRange = maxHeight - minHeight;
        const numCourses = courseNums.length;
        const numColumns = 3; 
        const coursesPerColumn = Math.ceil(numCourses / numColumns); 
        const heightPerCourse = heightRange / numCoursesRange; 
        const height2 = Math.max(minHeight, Math.min(maxHeight, coursesPerColumn * heightPerCourse));
        setHeight(height2);
      };
      calculateHeight();
    }, [courseNums]);

  const lowToHighQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => a[1] - b[1]);
    setCourseNums(sortedCourseNums); 
  };

  const highToLowQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => b[1] - a[1]);
    setCourseNums(sortedCourseNums);
  };

  const mostReviewsQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => b[0][0] - a[0][0]);
    setCourseNums(sortedCourseNums);
  };

  const highToLowDiffQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => {
      const avgA = a[0][1] / a[0][0]; // calculate the average of int2 per review for item a
      const avgB = b[0][1] / b[0][0]; // calculate the average of int2 per review for item b
      return avgB - avgA; // sort in ascending order of average int2 per review
    });
    setCourseNums(sortedCourseNums);
  };

  const lowToHighDiffQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => {
      const avgA = a[0][1] / a[0][0]; // calculate the average of int2 per review for item a
      const avgB = b[0][1] / b[0][0]; // calculate the average of int2 per review for item b
      return avgA - avgB; // sort in ascending order of average int2 per review
    });
    setCourseNums(sortedCourseNums);
  };

  const highToLowQualQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => {
      const avgA = a[0][2] / a[0][0]; // calculate the average of int2 per review for item a
      const avgB = b[0][2] / b[0][0]; // calculate the average of int2 per review for item b
      return avgB - avgA; // sort in ascending order of average int2 per review
    });
    setCourseNums(sortedCourseNums);
  };

  const lowToHighQualQuery = async () => {
    const sortedCourseNums = [...courseNums].sort((a, b) => {
      const avgA = a[0][2] / a[0][0]; // calculate the average of int2 per review for item a
      const avgB = b[0][2] / b[0][0]; // calculate the average of int2 per review for item b
      return avgA - avgB; // sort in ascending order of average int2 per review
    });
    setCourseNums(sortedCourseNums);
  };


function getReviewString(inputString) {
  let returnString;
  if (inputString === 1) {
    returnString = "1 review";
  } else {
    returnString = `${inputString} reviews`;
  }
  return returnString;
}

if (!department) return <Box>Loading...</Box>;

if (noReviews) {
  return(
  <ChakraProvider theme={theme}>
    <div style={{ 
        background: `url(${skyTwo}) center center fixed no-repeat`,
        backgroundSize: "cover",
        height: "100vh",
        width: "100vw",
        position: "relative"
      }}>
        <div style={{ 
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 224, 0.4)"
        }}>
    <VStack spacing='15px'>
    <VStack>

    </VStack>
  <VStack>
    <Center>
    <Box height="200px"/>
      <Box textAlign="center">
              <Heading size="lg" mb={4}>
                <div style={{ 
                  fontFamily: 'Helvetica Neue',
                  WebkitTextFillColor: 'black', // for Safari
                  textFillColor: 'black',
                  
                  }}>
                  {department} Department: 
                </div>
              </Heading>
              
              <div style={{ 
                  
                  WebkitTextFillColor: 'red', // for Safari
                  textFillColor: 'red',
                  
                  }}>
                  <Text fontSize='20px'>Sorry, there are no reviews yet...</Text>  
                </div>
              
      </Box>
      
    </Center>
    
  </VStack>
  <Center>
  <Stack direction='row' spacing={4}>
              <Button
                colorScheme='yellow'
                leftIcon={<AddIcon boxSize={15} />}
                >
                <Link href={'/reviewform'}>
                  Create Review
                </Link>
              </Button>
              <Box width="5px"/>
  </Stack> 
  </Center>
  
  </VStack>
  </div>
  </div>
  </ChakraProvider>
  );
} else {
  return (
    <Box minHeight={`${height}vh`}>
    <ChakraProvider theme={theme}>
      <div style={{ 
        background: `url(${skyTwo}) center center fixed no-repeat`,
        backgroundSize: "cover",
        height: `${height}vh`,
        width: "100vw",
        position: "relative"
      }}>
        <div style={{ 
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 224, 0.4)"
        }}>
      <Box>
      <Link href={`/departments/`}>  
        <HStack>
          <ArrowBackIcon size= "20px" color = 'black'>
          </ArrowBackIcon>
          <Text size= "30px" color = 'black' as='b'>Back</Text>
        </HStack>     
        </Link>
      </Box>
      <VStack>
        <Box width="10px"/>
        <HStack alignSelf={'end'}>
          <FormControl style={{backgroundColor: 'rgba(200, 200, 200, 0.9)'}}>
            <Select placeholder='Select option to filter by...' 
            onChange={(val) => {
              if (val.target.value === 'option1') {
                mostReviewsQuery();
              } else if (val.target.value === 'option2') {
                lowToHighQuery();
              } else if (val.target.value === 'option3') {
                highToLowQuery();
              } else if (val.target.value === 'option4') {
                lowToHighDiffQuery();
              } else if (val.target.value === 'option5') {
                highToLowDiffQuery();                
              } else if (val.target.value === 'option6') {
                lowToHighQualQuery();
              } else if (val.target.value === 'option7') {
                highToLowQualQuery();
              }
            }
            }>
              <option value='option1'>Most Reviews</option>
              <option value='option2'>Course Num, Low to High</option>
              <option value='option3'>Course Num, High to Low</option>
              <option value='option4'>Avg Difficulty, Low to High</option>
              <option value='option5'>Avg Difficulty, High to Low</option>
              <option value='option6'>Avg Quality, Low to High</option>
              <option value='option7'>Avg Quality, High to Low</option>
            </Select>
          </FormControl>
          <Box width="10px" />
        </HStack>
        <Box textAlign="center">
          <Heading size="lg" mb={4}>
            <div style={{ 
              fontFamily: 'Helvetica Neue',
              WebkitTextFillColor: 'black', // for Safari
              textFillColor: 'black',
              
              }}>
              {department} Department: 
            </div>
          </Heading>
        </Box>
        <Box height ={height}> 
        <SimpleGrid spacing={3} columns={3}>
        {courseNums.map((item) => (
          <div style={{ flex: 1 }} key={item[1]}>
            <Card style={{backgroundColor: '#ffd966'}} variant={'filled'}>
              <CardBody>
                <Stack spacing='3'>
                  <Link href={`/departments/${departmentName}/${item[1]}`}>
                    <Heading size='md' color='black'>{departmentCode}{item[1]}</Heading>
                  </Link>
                  <Text>
                      Average quality: {Math.round((item[0][2] / item[0][0])*100)/100}
                  </Text>
                  <Text>
                      Average difficulty: {Math.round((item[0][1] / item[0][0])*100)/100}
                  </Text>
                  <Text>
                    {getReviewString(item[0][0])}
                  </Text>
                </Stack>
              </CardBody>
            </Card>
          </div>
        ))}
        </SimpleGrid>
        </Box>
      </VStack>
      </div>
      </div>
    </ChakraProvider>
    </Box>
  );
}
}
